document.addEventListener('DOMContentLoaded', function() {
    // 1. Evaluate mobile user-agent ONLY ONCE on page load
    const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // 2. Only attach the document listener if the user is actually on a mobile device
    if (isMobile)
    {
        document.addEventListener('click', function(e) {
            // 3. Check if the clicked element is our link
            const link = e.target.closest('.pdf-deep-link');
            
            // 4. Exit immediately if the click was anywhere else on the page
            if (!link)
            {
                return;
            } 
            
            // 5. If we made it here, handle the PDF routing
            e.preventDefault(); 
            
            const originalHref = link.getAttribute('href');
            const urlParts = originalHref.split('#page=');
            
            if (urlParts.length === 2)
            {
                const fileUrl = encodeURIComponent(urlParts[0]);
                const pageNum = urlParts[1];
                
                const customViewerUrl = `search/pdf-viewer?file=${fileUrl}&page=${pageNum}`;
                window.open(customViewerUrl, '_blank', 'noopener,noreferrer');
            }
            else
            {
                window.open(originalHref, '_blank', 'noopener,noreferrer');
            }
        });
    }
});